export const Modules = [
    {
        id: 1,
        module: "Portfolio Module",
        view: 0,
        add: 0,
        edit: 0,
        delete: 0,
        isAdd: true,
        isEdit: true,
        isDelete: true
    },
    {
        id: 2,
        module: "News & Update Module",
        view: 0,
        add: 0,
        edit: 0,
        delete: 0,
        isAdd: true,
        isEdit: true,
        isDelete: true
    },
    {
        id: 3,
        module: "Customer Module",
        view: 0,
        add: 0,
        edit: 0,
        delete: 0,
        isAdd: true,
        isEdit: true,
        isDelete: true
    },
    {
        id: 4,
        module: "Staff Module",
        view: 0,
        add: 0,
        edit: 0,
        delete: 0,
        isAdd: true,
        isEdit: true,
        isDelete: true
    },
    {
        id: 5,
        module: "Roles Module",
        view: 0,
        add: 0,
        edit: 0,
        delete: 0,
        isAdd: true,
        isEdit: true,
        isDelete: true
    },
    {
        id: 6,
        module: "Contact Enquiry",
        view: 0,
        add: 0,
        edit: 0,
        delete: 0,
        isAdd: false,
        isEdit: false,
        isDelete: false
    },
    {
        id: 7,
        module: "Audit Logs",
        view: 0,
        add: 0,
        edit: 0,
        delete: 0,
        isAdd: false,
        isEdit: false,
        isDelete: false
    },
    {
        id: 8,
        module: "Testimonials",
        view: 0,
        add: 0,
        edit: 0,
        delete: 0,
        isAdd: true,
        isEdit: true,
        isDelete: true
    },
    {
        id: 9,
        module: "Meta Title & Description",
        view: 0,
        add: 0,
        edit: 0,
        delete: 0,
        isAdd: true,
        isEdit: true,
        isDelete: true
    },
    {
        id: 10,
        module: "Payout",
        view: 0,
        add: 0,
        edit: 0,
        delete: 0,
        isAdd: true,
        isEdit: true,
        isDelete: true
    },
    {
        id: 11,
        module: "Daily Trades",
        view: 0,
        add: 0,
        edit: 0,
        delete: 0,
        isAdd: false,
        isEdit: false,
        isDelete: false
    },
    {
        id: 12,
        module: "Customer Support",
        view: 0,
        add: 0,
        edit: 0,
        delete: 0,
        isAdd: false,
        isEdit: false,
        isDelete: false
    },
]